import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchWrapper } from "services/login";
import { handleReducer } from "helpers/storeReducer";
import {
  fetchVoiceoverUploads,
  fetchVoiceoverUploadsById,
  fetchPostVoiceoverByCsv,
  fetchPostVoiceoverBulk,
  fetchPostVoiceoverUploads,
} from "services/voiceover";

export const getUploads = createAsyncThunk(
  "voiceover/getUploads",
  async params => {
    try {
      const res = await fetchWrapper(fetchVoiceoverUploads, params);
      return res;
    } catch (error) {
      throw new Error(error?.message || "get upload data failed");
    }
  }
);
export const getManualUploads = createAsyncThunk(
  "voiceover/getManualUploads",
  async params => {
    try {
      const res = await fetchWrapper(fetchVoiceoverUploads, params);
      return res;
    } catch (error) {
      throw new Error(error?.message || "get upload data failed");
    }
  }
);
export const getUploadsById = createAsyncThunk(
  "voiceover/getUploadsById",
  async params => {
    try {
      const res = await fetchWrapper(fetchVoiceoverUploadsById, params);
      return res;
    } catch (error) {
      throw new Error(error?.message || "get upload data by id failed");
    }
  }
);

export const postVoiceoverCSV = createAsyncThunk(
  "voiceover/postVoiceoverCSV",
  async params => {
    try {
      const res = await fetchWrapper(fetchPostVoiceoverByCsv, params);
      return res;
    } catch (error) {
      throw new Error(error?.message || "post voiceover by csv failed");
    }
  }
);
export const postVoiceOverByMp3 = createAsyncThunk(
  "voiceover/postVoiceOverByMp3",
  async ({ languageId, uploadTypeId, files }, { getState }) => {
    try {
      const { userID } = getState().login;
      const uploadRes = await fetchWrapper(fetchPostVoiceoverUploads, {
        uploadTypeId,
        languageId,
        userId: userID,
        // required but random text is ok
        fileName: "voiceoverMp3.txt",
      });
      if (uploadRes.uploadId) {
        const formData = new FormData();
        Array.from(files).forEach(file => {
          formData.append("files", file);
        });
        formData.append("uploadId", uploadRes.uploadId);
        const res = await fetchWrapper(fetchPostVoiceoverBulk, formData);
        return res;
      }
      throw new Error("post voiceover by mp3 failed");
    } catch (error) {
      throw new Error(error?.message || "post voiceover by mp3 failed");
    }
  }
);
const initialState = {
  uploads: {
    isLoading: false,
    error: null,
    data: null,
  },
  manualUploads: {
    isLoading: false,
    error: null,
    data: null,
  },
  uploadsById: {
    isLoading: false,
    error: null,
    data: null,
  },
  postUploads: {
    isLoading: false,
    error: null,
    data: null,
  },
  postMp3: {
    isLoading: false,
    error: null,
    data: null,
  },
};
const voiceOverSlice = createSlice({
  name: "voiceOver",
  initialState,
  reducers: {},
  extraReducers: builder => {
    handleReducer({
      initialState,
      fetchAction: getUploads,
      stateTitle: "uploads",
      builder,
    });
    handleReducer({
      initialState,
      fetchAction: getManualUploads,
      stateTitle: "manualUploads",
      builder,
    });
    handleReducer({
      initialState,
      fetchAction: getUploadsById,
      stateTitle: "uploadsById",
      builder,
    });
    handleReducer({
      initialState,
      fetchAction: postVoiceoverCSV,
      stateTitle: "postUploads",
      builder,
    });
    handleReducer({
      initialState,
      fetchAction: postVoiceOverByMp3,
      stateTitle: "postMp3",
      builder,
    });
  },
});
const { reducer } = voiceOverSlice;
export default reducer;
